import './blackout.scss';

export default function Blackout(): JSX.Element {
	return <div className='blackout'></div>;
}
